import EngineModule           from '../../../EngineModule';
import { NS as StandingTVNS } from '../../../components/customers/standing/StandingTV/StandingTV';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-tv',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingTVNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
